// src/context/reducers/calendarReducer.js

export const initialCalendarState = {
    // ───────── UI SELECTION ─────────
    selectedDate: null,
    selectedItem: null,

    // ───────── DATA ─────────
    tasks: [],
    reminders: [],
    events: [],
    trackers: [],

    // ───────── SETTINGS ─────────
    settings: {
        calendarFilters: {
            tasks: true,
            reminders: true,
            events: true,
            birthdays: true,
            trackers: true,
        },
        enabledItemTypes: {
            tasks: true,
            reminders: true,
            events: true,
            birthdays: true,
            trackers: true,
        },
        itemTypeColors: {
            tasks: "#3b82f6",        // blue
            reminders: "#f59e0b",    // amber
            events: "#10b981",       // green
            birthdays: "#ec4899",    // pink
            trackers: "#8b5cf6",     // purple
            missedTrackers: "#6b7280", // neutral grey
        },
        showMissedTrackers: false,
    },
};

export default function calendarReducer(state, action) {
    switch (action.type) {
        // ───────── BULK LOAD / SYNC ─────────
        case "SET_CALENDAR_DATA":
            return {
                ...state,
                ...action.payload,
            };

        // ───────── UI SELECTION ─────────
        case "SET_SELECTED_DATE":
            return {
                ...state,
                selectedDate: action.payload,
            };

        case "SET_SELECTED_ITEM":
            return {
                ...state,
                selectedItem: action.payload,
            };

        // ───────── TASKS ─────────
        case "ADD_TASK":
            return {
                ...state,
                tasks: [...state.tasks, action.payload],
            };

        case "UPDATE_TASK":
            return {
                ...state,
                tasks: state.tasks.map((t) =>
                    t.id === action.payload.id ? action.payload : t
                ),
            };

        case "DELETE_TASK":
            return {
                ...state,
                tasks: state.tasks.filter((t) => t.id !== action.payload),
            };

        // ───────── REMINDERS ─────────
        case "ADD_REMINDER":
            return {
                ...state,
                reminders: [...state.reminders, action.payload],
            };

        case "UPDATE_REMINDER":
            return {
                ...state,
                reminders: state.reminders.map((r) =>
                    r.id === action.payload.id ? action.payload : r
                ),
            };

        case "DELETE_REMINDER":
            return {
                ...state,
                reminders: state.reminders.filter(
                    (r) => r.id !== action.payload
                ),
            };

        // ───────── EVENTS / BIRTHDAYS ─────────
        case "ADD_EVENT":
            return {
                ...state,
                events: [...state.events, action.payload],
            };

        case "UPDATE_EVENT":
            return {
                ...state,
                events: state.events.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };

        case "DELETE_EVENT":
            return {
                ...state,
                events: state.events.filter(
                    (e) => e.id !== action.payload
                ),
            };

        // ───────── TRACKERS ─────────
        case "ADD_TRACKER":
            return {
                ...state,
                trackers: [...state.trackers, action.payload],
            };

        case "UPDATE_TRACKER":
            return {
                ...state,
                trackers: state.trackers.map((t) =>
                    t.id === action.payload.id ? action.payload : t
                ),
            };

        case "DELETE_TRACKER":
            return {
                ...state,
                trackers: state.trackers.filter(
                    (t) => t.id !== action.payload
                ),
            };

        // ───────── SETTINGS ─────────
        case "UPDATE_CALENDAR_SETTINGS":
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.payload,
                },
            };

        default:
            return state;
    }
}
